module.exports = __webpack_public_path__ + "img/warning.4131bfb9.svg";